import React from 'react'
import Allusers from '../../Components/admin/Allusers'
function GetAllusers() {
  return (
    <div>
      <Allusers/>
    </div>
  )
}

export default GetAllusers
